import * as z from 'zod';

// ============================================
// Order Item Type Enum (from OrderItemTypeEnum.java)
// ============================================
const OrderItemTypeSchema = z.enum([
  'Event',
  'Inventory',
  'Combo',
  'ComboInventory',
  'RebookingFee',
  'MembershipPurchase',
  'MembershipRenewal',
  'MembershipUpgrade',
  'MembershipDowngrade',
  'MembershipCancel',
  'MembershipPostTermRenewal',
  'MembershipRejoin',
  'MembershipRenewalUpgrade',
  'MembershipPostTermRenewalUpgrade',
  'MembershipRejoinUpgrade',
  'MembershipPostTermRenewalDowngrade',
  'MembershipRejoinDowngrade',
  'MembershipRenewalDowngrade',
  'MembershipPurchaseConversion',
  'MembershipReplacement',
  'Donation',
  'Payment',
  'MembershipOfferingChange',
]);

// ============================================
// UpdateOrderItemInputVo Schema
// Maps to: UpdateOrderItemInputVo.java
// ============================================
const UpdateOrderItemInputSchema = z.object({
  orderItemId: z.coerce.number().optional(),
  eventId: z.string(),
  itemType: OrderItemTypeSchema,
  itemTypeId: z.union([z.string(), z.int()]), // TODO: b2bAddEventToOrder - `Inventory` type uses int, events use string
  quantity: z.int(),
  discountId: z.string().nullable().optional(),
  couponId: z.string().nullable().optional(),
  accountCategoryId: z.string().nullable().optional(),
  membershipId: z.coerce.number().nullable().optional(),
});

// ============================================
// OrderUpdateInputVo Schema (frontend-allowed fields only)
// Maps to: OrderUpdateInputVo.java
// ============================================
export const OrderUpdateInputSchema = z.object({
  // Required field - order to update
  orderId: z.coerce.number(),

  // Optional fields allowed from frontend
  accountId: z.int().nullable().optional(),
  notes: z.string().nullable().optional(),
  orderItems: z.array(UpdateOrderItemInputSchema).nullable().optional(),
  noEmail: z.boolean().optional().default(false), // Java primitive boolean defaults to false
  email: z.string().nullable().optional(),
  contactFirstName: z.string().nullable().optional(),
  contactLastName: z.string().nullable().optional(),
  zipCode: z.string().nullable().optional(),
  phoneNumber: z.string().nullable().optional(),
});

export type UpdateOrderItemInput = z.infer<typeof UpdateOrderItemInputSchema>;
export type OrderUpdateInput = z.infer<typeof OrderUpdateInputSchema>;
